export { InvalidOptionsError } from './InvalidOptionsError';